import Cookies from 'js-cookie';
import { CURRENT_EXPERIMENT_ENTITY_VERSION, CURRENT_TRACING_ENTITY_VERSION, CURRENT_USER_ENTITY_VERSION, } from './types.utils';
var getUrsDatabaseIdFromCookie = function () {
    var ursDatabaseIdRegex = /URS_DATABASE_ID=(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})/;
    var cookieString = Cookies.get('user') || '';
    var ursId = undefined;
    if (cookieString) {
        ursId = ursDatabaseIdRegex.exec(decodeURIComponent(cookieString));
    }
    return ursId ? ursId[1] : '';
};
var getABTestStringFromCookie = function () { return Cookies.get('abTestGroups') || ''; };
export var generateUserEntity = function () {
    var ursDatabaseId = getUrsDatabaseIdFromCookie();
    var logged_in = !!ursDatabaseId;
    return [
        logged_in
            ? {
                SCHEMA_KEY: CURRENT_USER_ENTITY_VERSION,
                logged_in: true,
                id: ursDatabaseId,
            }
            : {
                SCHEMA_KEY: CURRENT_USER_ENTITY_VERSION,
                logged_in: false,
            },
    ];
};
export var generateTracingEntity = function () {
    var requestId = typeof window !== 'undefined' ? window.AT_REQUEST_ID : false;
    return requestId
        ? [
            {
                SCHEMA_KEY: CURRENT_TRACING_ENTITY_VERSION,
                'x-request-id': requestId,
            },
        ]
        : [];
};
export var generateABTestGroupEntities = function () {
    var testGroupString = getABTestStringFromCookie();
    return testGroupString
        ? testGroupString.split('-').map(function (variant) { return ({
            SCHEMA_KEY: CURRENT_EXPERIMENT_ENTITY_VERSION,
            variant: variant,
        }); })
        : [];
};
